export function getUtmPreviewLink(
    baseUrl: string,
    options: {
        [key: string]: string | null | undefined;
    }
): string | null | undefined {
    const keys = Object.keys(options);
    const utmSearch = keys
        .filter((utmKey: string) => options[utmKey])
        .map((utmKey: string) => {
            let utmValue = options[utmKey];

            // Replace spaces with underscores
            // String cast due to trim function giving errors on null values
            utmValue = String(utmValue).trim().replace(/\s+/g, '_');

            return `utm_${utmKey}=${utmValue}`;
        })
        .join('&');

    return utmSearch.length ? `${baseUrl}?${utmSearch}` : null;
}
